import { ContentViewScreen } from 'app/features/content/view'
import { Content } from 'app/queries/content/content'
import { GetServerSideProps } from 'next'

import { dehydrate, QueryClient } from 'react-query'
import { withAuthedPage } from '../../lib/session'
import retrieveContent from '../../lib/content-retriever'
export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async (context) => {
    const { slug } = context.params as {
      slug: string
    }

    const queryClient = new QueryClient()

    const res = await retrieveContent(context, slug, queryClient)

    const dehydratedState = dehydrate(queryClient)

    return {
      props: {
        dehydratedState,
        content: res,
      },
      notFound: !res?.id,
    }
  }
)

interface ContentPageProps {
  content: Content
  series?: string
}

export default function ContentPage({ content }: ContentPageProps) {
  return (
    <ContentViewScreen
      content={content}
      series={content.isInSeries ? content.primaryCollectionId : ''}
    />
  )
}
